import { SortItem } from "@models/ss-api/responses/member.dashboard.license.response";
import { ISortable } from '../../helpers/sort';

export class CPUBenchmarkItemArray extends Array<CPUBenchmarkItem> implements ISortable {

    public LastSort = new SortItem;

    constructor(...items: CPUBenchmarkItem[]) {
        super(...items);
        Object.setPrototypeOf(this, CPUBenchmarkItemArray.prototype);
    }

    public static FixDates(items: CPUBenchmarkItemArray) {
        items.forEach(x => CPUBenchmarkItem.FixDates(x));
    }  

}

export class CPUBenchmarkItem  {
    CPUBenchmarkID: number;    
    CPUName: string;
    BenchmarkScore: number;
    LicenseCount: number;
    DateTimeCreated?: Date;
    DateTimeUpdated?: Date;

    public static FixDates(item: CPUBenchmarkItem) {
        if (item.DateTimeCreated != null && item.DateTimeCreated != undefined)
            item.DateTimeCreated = new Date(item.DateTimeCreated);

        if (item.DateTimeUpdated != null && item.DateTimeUpdated != undefined)
            item.DateTimeUpdated = new Date(item.DateTimeUpdated);

    }        
}
